import React from 'react'
import ErrorBoundary from '../../components/ErrorBoundary'

export default WrappedComponent => props => (
  <ErrorBoundary>
    <WrappedComponent {...props} />
  </ErrorBoundary>
)
